var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.222 4.822c0-.146-.058-.287-.162-.391L7.794 2.162C7.69 2.058 7.549 2 7.4 2h-.14v2.963h2.962v-.141zm4.329 4.308l-2.215-2.232c-.234-.234-.635-.07-.635.262v1.507H10.22v1.481H11.7v1.51c0 .33.4.495.635.261l2.215-2.234c.153-.153.153-.403 0-.555zm-8.773.648v-.741c0-.204.166-.37.37-.37h4.074V5.704H7.074c-.305 0-.555-.25-.555-.556V2h-4.63c-.308 0-.556.248-.556.556v10.74c0 .308.248.556.556.556h7.778c.308 0 .555-.248.555-.556v-3.148H6.148c-.204 0-.37-.167-.37-.37z",
    transform: "translate(-1253 -85) translate(1241 77) translate(12 8)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExport);
export default __webpack_public_path__ + "static/media/icon-export.462ca0ed349a56da8a0bd96be3256bf9.svg";
export { ForwardRef as ReactComponent };